import { AuthorizationError, AuthorizationResponse } from '@openid/appauth/built/authorization_response'
import { log } from '@openid/appauth/built/logger';
import { BasicQueryStringUtils } from '@openid/appauth/built/query_string_utils';
import { LocationLike } from '@openid/appauth/built/types';
import { AuthorizationServiceConfiguration } from '@openid/appauth/built/authorization_service_configuration';
import { AuthorizationRequest, AuthorizationRequestJson } from '@openid/appauth/built/authorization_request';
import { NucleusCrypto } from './NucleusCrypto';
import { Crypto } from '@openid/appauth/built/crypto_utils';
import { AuthorizationRequestHandler, AuthorizationRequestResponse } from '@openid/appauth/built/authorization_request_handler';
import { SecretsStore } from './SecretsStore';

const AUTHORIZATION_REQUEST_KEY = "nucleus_identity_request"



export class NucleusAuthorizationHandler extends AuthorizationRequestHandler {
  constructor(
    private store: SecretsStore,
    crypto: Crypto,
    public locationLike: LocationLike = window.location
  ) {
    super(new BasicQueryStringUtils(), crypto); //TODO: LiteCrypto is a temporary replacement for DefaultCrypto until this is published: https://github.com/openid/AppAuth-JS/pull/87/ 
  }

  async performAuthorizationRequest(configuration: AuthorizationServiceConfiguration, request: AuthorizationRequest) {
    var req = await request.toJson();
    this.store.setJson(AUTHORIZATION_REQUEST_KEY, req);
    let url = this.buildRequestUrl(configuration, request);
    log('Making a request to ', request, url);
    this.locationLike.assign(url);
  }

  public completeAuthorizationRequest(): Promise<AuthorizationRequestResponse | null> {
    let queryParams = this.utils.parse(this.locationLike, true /* use hash */);
    let state: string | undefined = queryParams['state'];
    let code: string | undefined = queryParams['code'];
    let error: string | undefined = queryParams['error'];

    if (!code && !error) {
      return null;
    }

    var reqJson = this.store.getJson<AuthorizationRequestJson>(AUTHORIZATION_REQUEST_KEY);
    var request = new AuthorizationRequest(reqJson);

    let currentUri = `${this.locationLike.origin}${this.locationLike.pathname}`;
    
    log('Potential authorization request ', currentUri, queryParams, state, code, error);
    let authorizationResponse: AuthorizationResponse | null = null;
    let authorizationError: AuthorizationError | null = null;

    if (state === request.state) {
      if (error) {
        // get additional optional info.
        let errorUri = queryParams['error_uri'];
        let errorDescription = queryParams['error_description'];
        authorizationError = new AuthorizationError({
          error: error,
          error_description: errorDescription,
          error_uri: errorUri,
          state: state
        });
      } else {
        authorizationResponse = new AuthorizationResponse({ code: code, state: state });
      }
      // cleanup state
      return Promise
        .all([
          this.store.remove(AUTHORIZATION_REQUEST_KEY),
        ])
        .then(() => {
          log('Delivering authorization response');
          return {
            request: request,
            response: authorizationResponse,
            error: authorizationError
          } as AuthorizationRequestResponse;
        });
    } else {
      log('Mismatched request (state and request_uri) dont match.');
      return Promise.resolve(null);
    }
  }
}
